import { useIntl } from 'react-intl';

import messages from './messages';

// Remove the tacky parentheses in the name provided by the API,
// e.g. "packet(s)" or "pump(s)" // en-CA, en-US
// "sachet(s)" or "pompe(s)"     // fr-CA
export const getNameWithoutParens = (name, quantity) => {
  if (name.includes('(s)')) {
    // regex is to look for (s), optionally preceded by one or more spaces,
    // as some units are formatted like `pump(s)`, while others are `pump (s)`
    const testRegex = /\s*\(s\)/;
    if (quantity === 1) {
      return name.replace(testRegex, '');
    }
    return name.replace(testRegex, 's');
  }
  return name;
};

const getProductLabel = ({
  currentQuantity,
  inRecipe,
  productOptionForm,
  productOptionName,
  unit,
}) => {
  const { formatMessage } = useIntl();
  // Example of the productOptionForm from props:
  // form: {
  //   availability: "Available",
  //   formCode: "qty",
  //   name:"Chestnut Praline Syrup",
  //   sizes: [{
  //     0: {sizeCode: "add", name: "Chestnut Praline Syrup", sku: "11033014"},
  //     1: {sizeCode: "sub", name: "Substitute Chestnut Praline Syrup", sku: "11033019"},
  //     2: {sizeCode: "no", name: "No Chestnut Praline Syrup", sku: "11033018"}
  //   }]
  // }

  // Products that can be reduced to a 0 quantity will have a sizeCode of 'no'
  const sizeCodeOfNoOption = (productOptionForm.sizes || []).find(
    (size) => size.sizeCode === 'no'
  );
  // An inactive option gets a label like `Add mocha sauce`
  let text = formatMessage(messages.addQuantityText, {
    productOptionName,
  });
  // If amount is decreased to 0, and the flavor is apart of the recipe,
  // then use size.name, i.e. 'No Chestnut Praline Syrup'
  if (currentQuantity === 0 && inRecipe && Boolean(sizeCodeOfNoOption)) {
    text = sizeCodeOfNoOption.name;
  } else if (currentQuantity > 0) {
    text = getNameWithoutParens(unit, currentQuantity);
  }
  return text;
};

export default getProductLabel;
